<template>
<v-container fluid pa-0 ma-0>

  <a tag="span" :href="currProj.link" class="projLabel d-flex bat mt-12 pt-12"> {{currProj.title}} </a>
  
  <a tag="div" :href="currProj.link" class="d-flex justify-center align-start">
    <div class="card-image ma-5" 
      :style="{ backgroundImage: 'url(' + image +')'}">
    </div>
  </a>

  <div class="detailHolder d-flex justify-center align-start flex-wrap pb-12">
    <div class="infoHolder d-flex flex-column justify-start align-center">
      <span class="mdProjLabel topper d-flex bat turq">Background</span>
      <div v-html="currProj.text" class="projInfo d-flex justify-center align-center mt-5 fs18">
        {{currProj.text}}
      </div>
    </div>
    <div class="stackHolder projStack d-flex flex-column justify-start align-center ml-0">
      <span class="mdProjLabel d-flex bat purp ceTxt mb-5">Development Stack</span>
      <div class="frontEnd projCard d-flex mx-2 elevation-4 mb-12 mt-5">
        <div class="frontStack d-flex flex-column z100">
          <div class="lgTitle d2 d-flex justify-space-between align-center px-8 py-4">
            <span class="paral fs30 lh30 whiteTxt">FRONT-END FRAMEWORK</span>
            <div class="d-flex justify-end align-center paral fs28 lh28 whiteTxt">
              <div class="vue stackLogo mr-2"></div>
              <span>{{currProj.frontFramework}}</span>
            </div>
          </div>
          <div class="mdTitle d1 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">COMPONENT FRAMEWORK</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <div class="vuetify stackLogo mr-2"></div>
              <span>{{currProj.frontLibrary}}</span>
            </div>
          </div>
          <div class="lgTitle d2 d-flex justify-space-between align-center px-8 py-4">
            <span class="paral fs30 lh30 whiteTxt">BACKEND LANGUAGE</span>
            <div class="d-flex justify-end align-center paral fs28 lh28 whiteTxt">
              <div class="node stackLogo mr-2"></div>
              <span>{{currProj.backLang}}</span>
            </div>
          </div>
          <div class="mdTitle d1 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">WEB SERVER</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <div class="nginx stackLogo mr-2"></div>
              <span>{{currProj.server}}</span>
            </div>
          </div>
          <div v-if="currProj.database" 
            class="mdTitle d2 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">DATABASE</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <div class="mongo stackLogo mr-2"></div>
              <span>{{currProj.database}}</span>
            </div>
          </div>
          <div v-if="currProj.database" 
            class="mdTitle d1 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">DATABASE CONNECTION</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <span>{{currProj.databaseConn}}</span>
            </div>
          </div>
          <div class="smTitle d2 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">SERVER FRAMEWORK</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <span>{{currProj.serverFrame}}</span>
            </div>
          </div>
          <div v-if="currProj.stateMan" 
            class="mdTitle d1 d-flex justify-space-between align-center px-8 py-3">
            <span class="paral fs26 lh26 whiteTxt">STATE MANAGEMENT</span>
            <div class="d-flex justify-end align-center paral fs26 lh26 whiteTxt">
              <span>{{currProj.stateMan}}</span>
            </div>
          </div>
          <div class="endTitle d2 d-flex pt-5"></div>
        </div>
      </div>
    </div>
  </div>

</v-container>
</template>
// ============================SCRIPT
<script>
import Projects from './Projects.json'
export default {
  data() {
    return{
      Projects,
      projectNum: 4,
      image: "",
      id: this.$route.params.id,
      currProj: "",

    }
  },
  watch: {
    '$route'(to){ this.id = to.params.id;},
    id(){ this.getProj();}
  },
  methods: {
    getProj(){ this.currProj = this.Projects[this.id];},
    path(url) { return require('../../images/backgrounds/' + url);}
  },
  created() { this.getProj();}, 
  mounted() { this.image = this.path(this.currProj.url);}
}
</script>
// ============================STYLE
<style scoped>
.projCard{
  height: auto !important;}
.detailHolder{
  width: 100vw;}
.projLabel{
  color: #282828DE;
  cursor: pointer;
  text-align: left;
  margin: 1.5vh 4vw;
  font-size: calc(20px + 2vw);}
.projLabel:hover{ color: #4EA792;}
.mdProjLabel{
  font-size: calc(18px + 1.5vw);
  line-height: calc(18px + 1vw);}
.infoHolder{
  width: 40vw;
  min-width: 450px;
  margin: 20px 5vw;}
.projStack{
  width: 40vw;
  min-width: 600px;
  margin: 25px 5vw;}
.card-image{
  background: center top;
  background-size: cover;
  position: relative;
  border-radius: 15px;
  width: 60vw;
  height: 30vw;}
</style>